import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ExportIcon } from '../../../../assets/icons/export.svg';
import { useAppSelector } from '../../../../redux/hooks';
import MyButton from '../../../../shared-components/button/Button';

/**
 * Component to show OCPP logs
 * @returns
 */
export default function OcppLogs() {
  const { t } = useTranslation('devices');
  const { messages } = useAppSelector((state) => state.ocppMessage);

  return (
    <div className="device-ocpp-logs-wrap">
      <div className="device-ocpp-logs-header">
        <h2>{t('oCPPLogs')}</h2>
        <MyButton
          label={t('export')}
          buttonType="primary-outline"
          svgIcon={<ExportIcon />}
          onClickFunc={() => {}}
        />
      </div>
      <div className="device-ocpp-logs-container">
        <div className="device-top-grey" />
        <div className="ocpp-logs-content">
          {messages
            .slice()
            .reverse()
            .map((message) => (
              <p>
                {message.type}: {message.value}
              </p>
            ))}
        </div>
      </div>
    </div>
  );
}
